import { render, staticRenderFns } from "./RelatoriosIndice.vue?vue&type=template&id=d6db8e2c&scoped=true&"
import script from "./RelatoriosIndice.vue?vue&type=script&lang=js&"
export * from "./RelatoriosIndice.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosIndice.vue?vue&type=style&index=0&id=d6db8e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6db8e2c",
  null
  
)

export default component.exports